export default "__VITE_ASSET__6rtVP4BT__"